import Accommodation from "@material-symbols/svg-500/rounded/domain.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const AccommodationIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Accommodation });
	return <Icon />;
};

export default memo(AccommodationIcon);
